import { z } from 'zod'

export const contactLogSchema = z.object({
  contact_method: z.enum(['phone', 'email', 'text', 'in_person']),
  person_contacted: z.string().optional(),
  summary: z.string().min(10, 'Summary must be at least 10 characters'),
  outcome: z.string().min(1, 'Outcome is required'),
  next_action: z.string().optional(),
  followup_date: z.string().optional(),
})

export type ContactLogFormData = z.infer<typeof contactLogSchema>
